<div class="parent" *ngIf="adminAuthenticated===false">
  <div class="admin-login-card p-3">
    <div class="logo mb-2" style="margin: auto; width: 80px;">
      <img src="../../assets/WhatsApp Image 2022-08-02 at 5.41.07 AM.jpeg" alt="">
    </div>
    <h4 class="mb-4 text-center">Admin Login</h4>
    <div class="input-group input-group-lg mb-3">
      <input type="email" class="form-control" placeholder="Enter email*" [(ngModel)]="adminCredentials.email">
    </div>
    <div class="input-group input-group-lg mb-3">
      <input type="password" class="form-control" placeholder="Enter password*" [(ngModel)]="adminCredentials.password">
    </div>

    <div *ngIf="showOTPfield == true">
      <hr>
      <small>Enter OTP sent to your email!</small>
      <div class="input-group input-group-lg mb-3">
        <input type="password" class="form-control" placeholder="Enter OTP*" [(ngModel)]="adminCredentials.OTP">
      </div>
    </div>

    <div *ngIf="invalidCredentialsAlert===true" class="alert alert-danger text-center" role="alert">
      Invalid Credentials!
    </div>
    <hr>

    <div class="row">
      <div class="col-6">
        <button type="button" class="btn btn-block btn-outline-danger mb-2" routerLink="/">Cancel</button>
      </div>
      <div class="col-6">
        <button type="button" class="btn btn-block btn-primary" (click)="onAdminLogin()" *ngIf="showOTPfield == false">Login</button>
        <button type="button" class="btn btn-block btn-primary" (click)="onOTPSubmit()" *ngIf="showOTPfield == true">Submit</button>
      </div>
    </div>
    <div class="text-center">
      <small>
        <a class="py-2" style="color: gray; cursor: pointer;" (click)="onForgotPassword()">Forgot Password?</a>
      </small>
    </div>
    <div *ngIf="passwordSent===true" class="alert alert-success mt-2" role="alert">
      Password sent to your email!
    </div>
  </div>
</div>

<div *ngIf="adminAuthenticated===true">
  <nav class="navbar navbar-expand-sm navbar-dark bg-dark">
    <div class="container">
      <a routerLink="/" class="navbar-brand">
        <div class="logo">
          <img src="../../assets/WhatsApp Image 2022-08-02 at 5.41.07 AM.jpeg" style="width: 40px;" alt="">
        </div>
      </a>
      <button class="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a style="cursor: pointer;" class="nav-link" (click)="onAppointmentsSelected()">Appointments</a>
          </li>
          <li class="nav-item">
            <a style="cursor: pointer;" class="nav-link" (click)="onQueriesSelected()">Queries</a>
          </li>
          <li class="nav-item">
            <a style="cursor: pointer;" class="nav-link" (click)="onLayoutSelected()">Layout</a>
          </li>
          <li class="nav-item">
            <a style="cursor: pointer;" class="nav-link" (click)="onSubjectsSelected()">Subjects</a>
          </li>
          <li class="nav-item">
            <a style="cursor: pointer;" class="nav-link" (click)="onServicesSelected()">Services</a>
          </li>
          <li class="nav-item">
            <a style="cursor: pointer;" class="nav-link" (click)="onAdminPanelSelected()">Admin</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <app-change-homepage-contents *ngIf="layoutSelected"></app-change-homepage-contents>
  <app-my-appointments *ngIf="appointmentSelected"></app-my-appointments>
  <app-my-queries *ngIf="queriesSelected"></app-my-queries>
  <app-update-services *ngIf="servicesSelected"></app-update-services>
  <app-update-subjects *ngIf="subjectsSelected"></app-update-subjects>
  <app-admin-panel *ngIf="adminPanelSelected"></app-admin-panel>

</div>
